<template>
	<div class="modal fade" id="modalDetailDevice" tabindex="-1" role="dialog" aria-labelledby="modalDetailDeviceTitle" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content mx-auto">                           
				<div class="modal-body">
					<p class="f-14 f-m-12"><b>Detail Kendaraan</b> 
						<button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</p>  
					<p class="title-colee f-12">Nama Kendaraan</p>
					<p class="f-14 f-m-12">{{ !detail?'':detail.merk }}</p>
					<hr>
					<p class="title-colee f-12">Jenis Kendaraan</p>
					<p class="f-14 f-m-12">{{ !detail?'':detail.type }}</p>
					<hr>
					<p class="title-colee f-12">Nomor polisi</p>
					<p class="f-14 f-m-12">{{ !detail?'':detail.nopol }}</p>
					<hr>
					<p class="title-colee f-12 mt-4">Status</p>
					<button class="info warning">{{ !detail?'':detail.col_status }}</button>
					<hr>
					<div class="row">
						<div class="col"><p class="title-colee f-12">Kapasitas</p><p class="f-14 f-m-12 margin-0">{{ !detail?'':detail.kapasitas }} kg</p></div>
						<div class="col"><p class="title-colee f-12">Panjang</p><p class="f-14 f-m-12 margin-0">{{ !detail?'':detail.panjang }} m</p></div>
						<div class="col"><p class="title-colee f-12">Lebar</p><p class="f-14 f-m-12 margin-0">{{ !detail?'':detail.lebar }} m</p></div>
						<div class="col"><p class="title-colee f-12">Tinggi</p><p class="f-14 f-m-12 margin-0">{{ !detail?'':detail.tinggi }} m</p></div>
					</div>                
					<hr>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalDetail',
	props: ['detail']
}
</script>